import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FeedbackConfirmationPopupService {
  public readonly feedbackConfirmationUrl = signal<string | undefined>(undefined);

  public openFeedbackConfirmation(url: string): void {
    this.feedbackConfirmationUrl.set(url);
  }

  public closeFeedbackConfirmation(): void {
    this.feedbackConfirmationUrl.set(undefined);
  }
}
